__turbopack_context__.v({
  "arrowIcon": "tdxWDq_arrowIcon",
  "backdrop": "tdxWDq_backdrop",
  "basic": "tdxWDq_basic",
  "basicLight": "tdxWDq_basicLight",
  "basicLightV2": "tdxWDq_basicLightV2",
  "copy": "tdxWDq_copy",
  "hasError": "tdxWDq_hasError",
  "hiddenInput": "tdxWDq_hiddenInput",
  "list": "tdxWDq_list",
  "listItem": "tdxWDq_listItem",
  "nativeButton": "tdxWDq_nativeButton",
  "nativeButtonDisabled": "tdxWDq_nativeButtonDisabled",
  "nativeList": "tdxWDq_nativeList",
  "nativePopover": "tdxWDq_nativePopover",
  "nativeSelectSlideUp": "tdxWDq_nativeSelectSlideUp",
  "outlined": "tdxWDq_outlined",
  "outlinedV2": "tdxWDq_outlinedV2",
  "popup": "tdxWDq_popup",
  "positioner": "tdxWDq_positioner",
  "select": "tdxWDq_select",
  "selectButton": "tdxWDq_selectButton",
  "selectSlideUp": "tdxWDq_selectSlideUp",
  "sizeM": "tdxWDq_sizeM",
  "value": "tdxWDq_value",
});
